import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  return (
    <div className="min-h-screen drafting-board grid place-items-center px-4">
      <form
        onSubmit={async (event) => {
          event.preventDefault();
          setError("");
          try {
            await login(email, password);
            navigate("/admin/dashboard");
          } catch (err) {
            setError(err.message);
          }
        }}
        className="paper paper-corner-fold w-full max-w-md p-7"
      >
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink-faint">Secure admin</p>
        <h1 className="font-display text-3xl mt-1">Login</h1>
        <label className="block mt-6 text-sm">
          Email
          <input className="mt-1 w-full border border-[var(--paper-edge)] bg-transparent p-2" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </label>
        <label className="block mt-4 text-sm">
          Password
          <input className="mt-1 w-full border border-[var(--paper-edge)] bg-transparent p-2" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </label>
        {error && <p className="mt-3 text-sm text-accentRed">{error}</p>}
        <button className="mt-6 w-full bg-ink text-paper px-4 py-3 font-mono text-[10px] uppercase tracking-[0.22em]">Login</button>
      </form>
    </div>
  );
};

export default Login;
